import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import React from "react";
import Tooltip from '@material-ui/core/Tooltip'

import RemoveIcon from '@material-ui/icons/RemoveCircle';

const RemoveDialog = (props) => {
	const [open, setOpen] = React.useState(false);
	const OnRemove = props.OnRemove;

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleRemove = () => {
		setOpen(false);
		OnRemove();
		// OnRemoveVehicle();
	}


	return (
		<div>
			<Tooltip title='Remove from geofence'>
				<IconButton aria-label="delete" onClick={handleClickOpen}>
					<RemoveIcon color="secondary" />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{"Remove Vehicle?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Remove the Vehicle from this Geofence?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleRemove} color="primary">
						Confirm Remove
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default RemoveDialog;
